import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo } from "react";
import { Scrollbars } from "react-custom-scrollbars";

const useStyle = makeStyles({
  container: {
    maxHeight: "100%",
    width: "100%",
    textAlign: "left",
    flexGrow: "0",
    margin: "10px 0 0",
    paddingRight: "16px",

  },
  textContent: {
    fontFamily: "DB Heavent",
  },
  paddingTopBottom: {
    padding: "20px 0",
  },
});

const ScrollBarComponent = (props) => {
  const classes = useStyle();
  const { content, isCheck, onChangeCheck } = props;

  const handleUpdate = (e) => {
    if (e.top >= 0.99 && isCheck) {
      onChangeCheck(true);
    }
  };

  return (
    <Scrollbars
      className={classes.container}
      onUpdate={handleUpdate}
      autoHide
      autoHideTimeout={500}
      autoHideDuration={200}
    >
      <Grid className="pr-4">{content}</Grid>
    </Scrollbars>
  );
};

export default memo(ScrollBarComponent);
